import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class ContactHost extends Vue {
  @Getter getSubscription;

  contactHost() {
    const { subscription_host } = this.getSubscription;
    window.open(`https://wa.me/${subscription_host.cellphone}`, "_blank");
  }
}
